function typedEntries(obj) {
  return Object.entries(obj);
}

export { typedEntries };
